import EArkisto from './EArkisto/fi.json';
import errorCodes from './errorCodes/fi.json';
import HomePage from './HomePage/fi.json';
import medicineListListFi from './MedicineList/fi.json';
import addTaskFi from './AddTask/fi.json';
import tasksFi from './Tasks/fi.json';
import notFoundFi from './NotFound/fi.json';
import sidenavitemFi from './SideNavItem/fi.json';
import searchBarFi from './SearchBar/fi.json';
import ReportDisplayFi from './ReportDisplay/fi.json';
import topHeaderFi from './TopHeader/fi.json';
import settingsFi from './Settings/fi.json';
import addReport from './AddReport/fi.json';
import customers from './Customers/fi.json';
import networkResponseHandler from './NetworkResponseHandler/fi.json';
import extranet from './Extranet/fi.json';
import errorBoundary from './Errors/fi.json';
import employeeAssignmentFi from './EmployeeAssignment/fi.json';
import bookingFi from './Booking/fi.json';
import DomaOSMMapFi from './DomaOSMMap/fi.json';
import documents from './Documents/fi.json';
import raiStats from './RaiStats/fi.json';
import careplanFi from './Careplan/fi.json';
import commonTranslationsFi from './CommonTranslations/fi.json';
import rai from './RAI/fi.json';
import Diagnosis from './Diagnosis/fi.json';
import ServicePackets from './ServicePackets/fi.json';
import messageCenter from './MessageCenter/fi.json';
import Duties from './Duties/fi.json';
import PreferredEmployeesFi from './Customers/PreferredEmployees/fi.json';
import RoomsFI from './Customers/Rooms/fi.json';
import Calendar from './Calendar/fi.json';
import WorkPlanning from './WorkPlanning/fi.json';
import OptimizationFI from './RouteOptimization/fi.json';
import TaskAuction from './TaskAuction/fi.json';
import CustomersSettings from './Customers/Settings/fi.json';
import utils from './utils/fi.json';
import Login from './Login/fi.json';
import FrontPage from './FrontPage/fi.json';
import AddBillingModal from './Customers/AddBillingModal/fi.json';
import App from './App/fi.json';
import ServicesTable from './Customers/ServicesTable/fi.json';
import Payroll from './Payroll/fi.json';
import EResepti from './EResepti/fi.json';
import SocialArchive from './Customers/SocialArchive/fi.json';
import CustomerGoals from './Customers/CustomerGoals/fi.json';
import HilmoTranslation from './Customers/Hilmo/fi.json';
import DVVCardLoginTranslation from './DVVCardLogin/fi.json';
import Ordinals from './Ordinals/fi.json';

const fiLocale = {
  ...errorCodes,
  ...HomePage,
  ...medicineListListFi,
  ...notFoundFi,
  ...sidenavitemFi,
  ...searchBarFi,
  ...addTaskFi,
  ...tasksFi,
  ...FrontPage,
  ...ReportDisplayFi,
  ...topHeaderFi,
  ...settingsFi,
  ...addReport,
  ...networkResponseHandler,
  ...extranet,
  ...errorBoundary,
  ...employeeAssignmentFi,
  ...bookingFi,
  ...DomaOSMMapFi,
  ...documents,
  ...utils,
  ...raiStats,
  ...customers,
  ...commonTranslationsFi,
  ...rai,
  ...Diagnosis,
  ...careplanFi,
  ...ServicePackets,
  ...messageCenter,
  ...Duties,
  ...PreferredEmployeesFi,
  ...RoomsFI,
  ...Calendar,
  ...App,
  ...WorkPlanning,
  ...OptimizationFI,
  ...TaskAuction,
  ...CustomersSettings,
  ...Login,
  ...AddBillingModal,
  ...ServicesTable,
  ...Payroll,
  ...EResepti,
  ...SocialArchive,
  ...CustomerGoals,
  ...EArkisto,
  ...HilmoTranslation,
  ...DVVCardLoginTranslation,
  ...Ordinals,
};

export default fiLocale;
